<template>
  <v-dialog v-model="dialog" persistent max-width="400px" style="margin: auto 4px">
    <v-card>
      <v-card-title>
        <span class="headline">Change Password</span>
      </v-card-title>
      <v-card-text>
        <v-form v-if="dialog" ref="form" v-model="formValid" @submit.prevent="changePwd()">
          <v-text-field ref="oldPassword"
                        v-model.trim="oldPassword"
                        :type="hidePassword ? 'password' : 'text'"
                        :rules="passwordRules"
                        :append-icon="hidePassword ? 'visibility' : 'visibility_off'"
                        label="Old Password"
                        autofocus
                        @click:append="hidePassword = !hidePassword"
                        @keyup.enter="changePwd()" />
          <v-text-field v-model.trim="password"
                        :type="hidePassword ? 'password' : 'text'"
                        :rules="newPasswordRules"
                        :append-icon="hidePassword ? 'visibility' : 'visibility_off'"
                        label="New Password"
                        @click:append="hidePassword = !hidePassword"
                        @keyup.enter="changePwd()" />
          <v-text-field v-model.trim="confirmPassword"
                        :type="hidePassword ? 'password' : 'text'"
                        :rules="[v => v === password || 'Must Match New Password']"
                        :append-icon="hidePassword ? 'visibility' : 'visibility_off'"
                        label="Confirm New Password"
                        @click:append="hidePassword = !hidePassword"
                        @keyup.enter="changePwd()" />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn flat @click="dialog = false">
          Cancel
        </v-btn>
        <v-btn :loading="loading" color="primary" @click="changePwd()">
          Change
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { rules } from '$app/validations'

  const defaults = () => ({
    loading: false,
    formValid: false,
    invalidPassword: false,
    oldPassword: '',
    password: '',
    confirmPassword: '',
    hidePassword: true
  });

  export default {
    props: ['value'],
    data: () => ({
      ...defaults()
    }),
    computed: {
      passwordRules() {
        return [...rules.required, () => !this.invalidPassword || 'Wrong Password'];
      },
      newPasswordRules() {
        return [
          ...rules.required,
          ...rules.minLength(8),
          v => /[a-z]/.test(v) || 'Must contain a lowercase letter',
          v => /[A-Z]/.test(v) || 'Must contain an uppercase letter',
          v => /[^a-zA-Z\s]/.test(v) || 'Must contain a number or special character'
        ];
      },
      dialog: {
        get() {
          return this.value;
        },
        set(val) {
          if (!val) {
            this.reset();
          }
          this.$emit('input', val);
        }
      }
    },
    watch: {
      oldPassword() {
        this.invalidPassword = false;
      }
    },
    methods: {
      changePwd() {
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.$http.post('account/ChangePassword', { password: btoa(this.password), oldPassword: btoa(this.oldPassword) })
            .then(resp => {
              if (resp && resp.data && resp.data.success) {
                this.$snackbar('Password Changed Successfully', 'success');
                this.dialog = false;
              } else {
                this.invalidPassword = true;
                this.$refs.form.validate();
                this.$refs.oldPassword.focus();
              }
            })
            .catch(() => this.$snackbar('Error Changing Password', 'error'))
            .finally(() => { this.loading = false; });
        }
      },
      reset() {
        Object.assign(this, defaults());
        this.$refs.form.reset();
      }
    }
  }
</script>
